import { ListingSection } from 'listing-details/types';

const getListingSectionFromString = (section: string): ListingSection => {
    if (['for-sale', 'to-rent', 'new-homes', 'overseas'].includes(section)) {
        return section as ListingSection;
    }

    return 'for-sale';
};

export default getListingSectionFromString;
